import { adminCompaniesEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiCompanyHandler } from "@/services/shared";
import type { ApiCompanyType, CompanyType } from "@/types";

export const getCompanyByIdHandler = async (id: number | string): Promise<CompanyType> => {
    const response = await axiosClient.get<{ company: ApiCompanyType }>(adminCompaniesEndpoints.byId(id));

    return transformApiCompanyHandler(response.data.company);
};
